import { useIsSplitEnabled } from '@buffer-mono/features'

const COMPOSER_ZUSTAND_MODE_STATE_FLAG = 'composer-zustand-mode-state'

/**
 * Kill-switch for the mode/selection-state migration track. On: `channelSlice`
 * is the sole writer for channel selection — `ChannelSelector.tsx` calls
 * Zustand only, mirrored to Flux by `installZustandToChannelSelectionMirror`.
 * Off: `ChannelSelector.tsx` keeps its existing dual-dispatch to both stores.
 */
export function useModeStateEnabled(): boolean {
  return useIsSplitEnabled(COMPOSER_ZUSTAND_MODE_STATE_FLAG)
}
